import { QueryConfig } from "store/utils/query-config";

export const supplierBillsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["billedAt"],
  },
};

export function supplierBillsQueryForBooking(bookingId: string): QueryConfig {
  // Include voided bills too. The Supplier Bills summary tab renders them
  // (badged/strikethrough, excluded from totals). Per-product consumers
  // (useSupplierPaymentData) still ignore voided bills via a local
  // `voided !== true` guard, so dropping the filter here is safe.
  return {
    query: { bookingId },
    options: { sortBy: ["billedAt"] },
  };
}
